import axios from "axios";
import { config } from "@/config/constants.js";
import router from "@/router/index.js";

export default {
  namespaced: true,
  state: {
    status: "",
    forgot_status: "",
    token: localStorage.getItem(config.token_key) || "",
    user: {},
  },
  mutations: {
    auth_request(state) {
      state.status = "loading";
    },
    auth_success(state, data) {
      state.status = "success";

      if (data && data["token"]) {
        state.token = data.token;
        axios.defaults.headers.common["Authorization"] = state.token;
        localStorage.setItem(config.token_key, state.token);
      }

      if (data && data["user"]) {
        state.user = data.user;
      }
    },
    forgot_status(state, data) {
      state.forgot_status = data;
    },
    auth_error(state) {
      state.status = "error";
      localStorage.removeItem(config.token_key);
      axios.defaults.headers.common["Authorization"] = state.token = "";
    },
    logout(state) {
      state.status = "";
      state.token = "";
      state.user = {};
      localStorage.removeItem(config.token_key);
      axios.defaults.headers.common["Authorization"] = state.token = "";
    },
  },
  actions: {
    login({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        axios
          .post(config.api_url + "login", user)
          .then((response) => {
            commit("auth_success", { 
              token: response.data.user.access_token, 
              user:response.data.user  
            });
            resolve(response.data.user);
          })
          .catch((err) => {
            console.log(err);
            commit("auth_error");
            reject(err);
          });
      });
    },
    forgot_password({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit("forgot_status", "loading");
        axios
          .post(config.api_url + "forgot_password", user)
          .then((response) => {
            commit("forgot_status", "complete");
            resolve(response.data);
          })
          .catch((err) => {
            console.log(err);
            commit("forgot_status", "error");
            reject(err.response.data);
          });
      });
    },
    reset_forgot_password({ commit }) {
      return new Promise((resolve) => {
        commit("forgot_status", "");
        resolve();
      });
    },
    logout({ commit }) {
      commit("logout");
      router.push("/");
    },
    me({ commit }) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        axios
          .get(config.api_url + "profile")
          .then((response) => {
            commit("auth_success", { user: response.data.user });
            resolve(response.data.user);
          })
          .catch((err) => {
            console.log(err);
            commit("auth_error");
            reject(err);
          });
      });
    },
  },
  getters: {
    isLoggedIn(state) {
      return state.token && state.token != undefined;
    },
    check_permission(state) {
      return (
        state.user &&
        ["sadmin", "admin","user_admin2", undefined].includes(state.user["role"])
      );
    },
    check_permission_delete(state) {
      return (
        state.user &&
        ["sadmin", "admin","user_admin", undefined].includes(state.user["user_role"])
      );
    },
    can_edit(state) {
      return function (section) {
        if (["projects"].includes(section)) {
          return (
            state.user &&
            state.user.role &&
            ["sadmin", "admin", "pm"].includes(state.user.role)
          );
        }

        return false;
      };
    },
  },
  modules: {},
};
